export const Logo = ({ size = "md", light = false, testId }) => {
  const img = size === "sm" ? "h-9 w-9" : "h-11 w-11 sm:h-[52px] sm:w-[52px]";
  const text = size === "sm" ? "text-[15px]" : "text-[17px] sm:text-[20px]";
  return (
    <a href="#beranda" className="flex items-center gap-2.5 shrink-0" aria-label="Nanina Care, ke beranda" data-testid={testId}>
      <img src="/logo-nanina.png" alt="Logo resmi Nanina Care" className={`${img} object-contain`} width="52" height="52" />
      <span className={`${text} font-extrabold tracking-tight leading-none ${light ? "text-white" : "text-nanina-green"}`}>
        NANINA CARE
      </span>
    </a>
  );
};
